import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { memo } from 'react';

import ContentCheckbox from 'src/components/task/surgeryCalendar/ContentCheckbox';
import { getField } from 'src/common/helper';

const colorBorderTable = '#DDDDDD';

const defaultBodyContentMeeting = {
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '1rem'
}


const DataCalendarTimes = (props: any) => {
  return props.daysTimes.map((time: any, index: number) => (
    <TableRow
      hover
      sx={{ height: '30px', cursor: 'pointer' }}
      key={`${time['hm']}-${index}`}
    >
      {time &&
        time['columns'] &&
        time['columns'].map((column: any, index: number) =>
          index === 0 ? (
            <TableCell
              key={`${time['hm']}-${index}`}
              align='left'
              sx={{
                fontSize: '14px',
                fontWeight: 400,
                lineWeight: '14.4px',
                '&.MuiTableCell-body': {
                  borderBottom: '0px',
                  borderTop: time['show']
                    ? `1px solid ${colorBorderTable}`
                    : '0px',
                  // borderRight: indexSelectDate?.indexStart === -1 ? '3px solid #23B7E5 !important' : ''
                },
              }}
            >
              {column['text'][0]['label']}
            </TableCell>
          ) : column['text'] ? (
            <TableCell
              key={time['hm'] + column['index']}
              align='left'
              rowSpan={column['rowspan'] ? column['rowspan'] : 6}
              sx={{
                height: `${(column['rowspan'] === 0 ? 6 : column['rowspan']) * 30
                  }px`,
                verticalAlign: 'top',
                bgcolor: column['color']['bg'],
                '&.MuiTableCell-body': {
                  borderBottom: '0px',
                  borderTop: time['show'] ? '1px solid #DDDDDD' : '0px',
                  // borderRight: indexSelectDate?.indexEnd === column['index']
                  //   || indexSelectDate?.indexStart === column['index'] ? '3px solid #23B7E5 !important' : ''
                },
              }}
              onClick={() =>
                props.handleOpenDialogDetail(column['id'], column['patientid'])
              }
            >
              <Box
                sx={{
                  py: '6px',
                  height: `${(column['rowspan'] === 0 ? 6 : column['rowspan']) * 30
                    }px`,
                }}
              >
                <Stack
                  sx={{
                    width: '100%',
                    height: '100%',
                    bgcolor: column['color']['bg'],
                    p: '6px',
                    borderRadius: '4px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    minHeight: '100%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    '& *': {
                      cursor: 'pointer',
                    },
                  }}
                >
                  <Box>
                    {getField(column, 'warning', 0) === 1 && (
                      <Box
                        component={'img'}
                        src={'/images/icons/ic-warning-outline-red.svg'}
                        alt='warning'
                        sx={{ width: '20px', height: '20px', mr: '5px' }}
                      />
                    )}
                    
                    <Typography
                      sx={{ ...defaultBodyContentMeeting }}
                      component='div'
                      dangerouslySetInnerHTML={{
                        __html: getField(column['text'], 'kana', ''),
                      }}
                    />

                    <Typography
                      sx={{ ...defaultBodyContentMeeting }}
                      component='div'
                      dangerouslySetInnerHTML={{
                        __html: getField(column['text'], 'fullname', ''),
                      }}
                    />

                    <Typography
                      sx={{ ...defaultBodyContentMeeting }}
                      component='div'
                      dangerouslySetInnerHTML={{
                        __html: getField(column['text'], 'age', ''),
                      }}
                    />

                    <Stack direction={'row'} spacing={'10px'}>
                      <Typography
                        sx={{ ...defaultBodyContentMeeting }}
                        component='label'
                      >開始時間</Typography>
                      <Typography
                        sx={{ ...defaultBodyContentMeeting }}
                        component='div'
                        dangerouslySetInnerHTML={{
                          __html: getField(column['text'], 'starttime', ''),
                        }}
                      />
                    </Stack>

                    <ContentCheckbox task={getField(column['text'], 'task', [])} />

                  </Box>
                </Stack>
              </Box>
            </TableCell>
          ) : (
            <TableCell
              key={time['hm'] + column['index']}
              align='left'
              sx={{
                '&.MuiTableCell-body': {
                  borderBottom: '0px',
                  borderTop: time['show'] ? '1px solid #DDDDDD' : '0px',
                  // borderRight: indexSelectDate?.indexEnd === column['index']
                  //   || indexSelectDate?.indexStart === column['index'] ? '3px solid #23B7E5 !important' : ''
                },
              }}
              onClick={() => props.handleOpenDialogAddReserve(time['hm'])}
            />
          )
        )}
    </TableRow>
  ));
};

export default memo(DataCalendarTimes);
